export enum TtsState {
  Stopped = "stopped",
  Playing = "playing",
  Paused = "paused",
}

export enum TtsAction {
  Start = "start",
  Pause = "pause",
  Resume = "resume",
}

export function nextTtsAction(state: TtsState): TtsAction {
  switch (state) {
    case TtsState.Playing:
      return TtsAction.Pause;
    case TtsState.Paused:
      return TtsAction.Resume;
    case TtsState.Stopped:
      return TtsAction.Start;
  }
}
